import { globalHistory } from '@gatsbyjs/reach-router';
import { navigate } from 'gatsby';

import { enhanceHistory } from '@skippay/core/utils/routeUtils';

export default enhanceHistory(globalHistory, navigate);
